app.navController = app.navController || {};

app.navController.indexAction = {
    
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.burger();
        this.subMenu();
    },
    
    burger : function () {
        var $body = $('body');
        // Toggle active class on burger btn when clicked
        var $burgerBtn = $('.burgerBtn');
        if ($burgerBtn.length) {
           $burgerBtn.on('click', function() {
               $burgerBtn.toggleClass('active');
               $body.toggleClass('activeNav');
           }); 
        }
    },
    
    subMenu : function () {
        var $subMenu = $('.mainNav .sub-menu');
        if ($subMenu.length > 0) {
            $subMenu.each(function() {
                var $subMenu = $(this),
                    subMenuHeight = $subMenu.height(),
                    $parentLink = $subMenu.parent('.menu-item');
                $subMenu.height('0');

                $parentLink.on('click', '> a', function(event) {
                    event.preventDefault();
                        if ($subMenu.height() > 0) {
                            $subMenu.animate( {height: 0}, 300);
                        }
                        else {
                            $subMenu.animate({height: subMenuHeight}, 300);
                        }
                        $subMenu.toggleClass('active');
                });
            });
                
            $('body').on('click', function(event) {
                var $target = $(event.target);
                if (! $target.parents('.mainNav').length > 0) {
                    $subMenu.animate({height: 0}, 300);
                    $subMenu.removeClass('active');
                }
            });
        }
    }

};